import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {TimeUtil} from '../../utils/timeUtil.js';
import {BaseComponent} from '../basecomponent.js';


/* global customElements */
class CachingControlGrid extends BaseComponent {
	
	static get properties() {
		return {	
			nodeId: {type: String}
		};
	}
	
	constructor() {
		super();
		
		var cachingGrid = this;
		setTimeout(function(){
			cachingGrid.init();
		});
	}
	
	render() {	
		return html`
			<slot></slot>		
		`;
	}
	
	init() {
		var cachingGrid = this;
		
		var toolbar = ElementUtil.create({
			tag: 'dl-toolbar',
			slot: 'toolbar',
			theme: 'spacing',
			children: [
				{
					tag: 'vaadin-button',
					itemid: 'refresh',
					'class': 'spacer-toolbar-item',
					children:[
						ElementUtil.makeIcon('vaadin:refresh', ' Refresh')
					], 
					listeners: {
						click: function() {
							actionRefresh();
						}
					}
				},
				{
					tag: 'dl-action-button',
					itemid: 'cacheManagerIdentity',
					'class': 'spacer-toolbar-item',
					permissions: ['ADMIN_SYSTEM:READ'],
					children: [
						ElementUtil.makeIcon('vaadin:info-circle', ' Cache manager identity')
					],
					listeners: {
						click: function() {
							actionShowCacheManagerIdentity();
						}
					}
				},
				{
					tag: 'dl-action-button',						
					theme: 'contrast primary',
					itemid: 'flush',					
					'class': 'spacer-toolbar-item',
					style: 'float: right;',
					permissions: ['ADMIN_SYSTEM:DELETE'],
					children:[
						ElementUtil.makeIcon('vaadin:rotate-right', ' Flush Cache')
					],
					listeners: {
						click: function() {
							actionFlushCache(grid.selectedItems[0]);
						}
					}
				}				
				
			]
		});		
		
		var grid = ElementUtil.create({
			tag: 'vaadin-grid',
			theme: 'row-stripes column-borders',
			'column-reordering-allowed': '',
			style: 'height: 100%;',			
			slot: 'primary',
			defaults: {
				tag: 'vaadin-grid-sort-column',
				resizable: true
			},			
			children: [				
				{						
					path: 'name',
					header: 'Name',
					width: '5em'
				},
				{						
					path: 'hits',
					header: 'Hits',
					'text-align': 'center',
					width: '5em'
				},
				{
					path: 'misses',
					header: 'Misses',
					width: '5em'										
				},
				{
					path: 'roughCount',
					header: 'Rough Count',
					width: '5em'										
				},				
				{						
					path: 'hitPercentage',
					header: 'Hit Percentage',					
					'text-align': 'center',
					'flex-grow': '1',
					renderer: function(root, column, rowData) {						
						root.innerHTML = Math.round(rowData.item.hitPercentage) + '%<br><vaadin-progress-bar value="' + (rowData.item.hitPercentage / 100) + '"></vaadin-progress-bar>';						
					}
				}
			],
			listeners: {
				'active-item-changed': function(event) {
					const item = event.detail.value;
					grid.selectedItems = item ? [item] : [];
					if (grid.selectedItems.length > 0) {						
						ElementUtil.query(toolbar, 'flush').disabled = false;
					} else {
						ElementUtil.query(toolbar, 'flush').disabled = true;
					}	
				}
			}
		});	
		
		var flexLayout = ElementUtil.create({
			tag: 'dl-flex-layout',
			children: [
				toolbar,
				grid
			]
		});		
		cachingGrid.append(flexLayout);		
		
		
		var actionRefresh = function() {
			var loadMask = cachingGrid.showLoading();	
			Service.getNodeService().getCaches(cachingGrid.nodeId).then(function(caches){
				loadMask.remove();
				
				grid.activeItem = null;
				grid.items = caches;				
			});					
			
		};
		actionRefresh();
		
		var actionFlushCache = function(record) {
			var loadMask = cachingGrid.showLoading('Flushing ' + record.name + '...');
			Service.getNodeService().flushCache(cachingGrid.nodeId, record.name).then(function(result){
				loadMask.remove();
				if (result && result.success) {
					window.DL.MessageUtil.showToast('Success', record.name + ' was flushed', {									
						theme: 'success'
					});				
					
					actionRefresh();
				}
			});
		};

		var escapeHtmlForDialog = function(text) {
			if (text == null) {
				return '';
			}
			return String(text)
				.replace(/&/g, '&amp;')
				.replace(/</g, '&lt;')
				.replace(/>/g, '&gt;')
				.replace(/"/g, '&quot;');
		};

		var actionShowCacheManagerIdentity = function() {
			var loadMask = cachingGrid.showLoading('Loading cache manager identity...');
			Service.getNodeService().getCacheManagerIdentity(cachingGrid.nodeId).then(function(identityText){
				loadMask.remove();
				var body = '<pre style="white-space: pre-wrap; word-break: break-word; max-width: min(50em, 90vw); max-height: min(28em, 60vh); overflow: auto; font-size: 0.85em; margin: 0;">'
					+ escapeHtmlForDialog(identityText) + '</pre>';
				window.DL.MessageUtil.showOkMessage(body, null, {
					title: 'JSR-107 CacheManager identity (node ' + escapeHtmlForDialog(cachingGrid.nodeId) + ')'
				});
			}).catch(function() {
				loadMask.remove();
			});
		};

		
	}
	
};
customElements.define('dl-cachingcontrol-grid', CachingControlGrid);
